import { ChecklistIcon, HStack, Icon, LocationPinIcon, PictureIcon, Text } from 'aos-ui-universal'
import React, { FC } from 'react'

interface TaskMetaIconsProps {
    hasLocation?: boolean
    attachmentsLength?: number
    hasChecklist?: boolean
}

export const TaskMetaIcons: FC<TaskMetaIconsProps> = ({
    hasLocation,
    attachmentsLength = 0,
    hasChecklist,
}) => (
    <HStack space='sm' className='shrink-0 items-center flex-1 justify-end'>
        {hasLocation ? (
            <Icon as={LocationPinIcon} size={24} className='text-content-muted' />
        ) : null}
        {attachmentsLength > 0 ? (
            <HStack space='xs' className='items-center'>
                <Icon as={PictureIcon} size={24} className='text-content-muted' />
                <Text size='caption' weight='medium' tone='muted'>
                    {attachmentsLength}
                </Text>
            </HStack>
        ) : null}
        {hasChecklist ? <Icon as={ChecklistIcon} size={24} className='text-content-muted' /> : null}
    </HStack>
)
